module.exports = {
  label: {
    headerTitle: 'My Request',
    addHeaderTitle: 'View My Request',
    siteName: 'Site Name',
    visitorName: 'Visitor Name',
    accessDate: 'Access Date',
    hostUserName: 'Host User Name',
    visitorRemarks: 'Visitor Remarks',
    questions: 'Questions',
    siteRemarks: 'Site Remarks',
    status: 'Status',
    search: 'Search...',
    noData:'---',
    fromDateRange: 'From Date',
    toDateRange: 'To Date',
    showPagination: {
      showing: 'Showing',
      to: 'to',
      of: 'of',
      entries: 'entries',
      rowsSelected: 'rows selected'
    },
    tooltips: {
      view: 'View'
    },
    buttons: {
      add: 'Add',
      save: 'Save',
      cancel: 'Cancel'
    }
  }
}
